import { useRef, useState, useEffect } from "react"
import { useIntl } from "react-intl"
import { useSelector, useDispatch } from "react-redux";
import { Alert } from '@mui/material';
//Components
import {
    Modal,
    ModalBody,
    ModalFooter,
    Form,
    Button,
    Input
} from "@gpstrackit/react-controls";

//Notification
import {
    NotificationManager
} from "Components/Notifications";

//Helpers
import { passwordValidation } from 'Utils/helpers';

//Actions
import { loginOpenModalChangePassword, forceChangePasswordRequest, clearRedux } from 'Redux/actions';
import { useNavigate } from "react-router-dom";

//Styles
import "./changePassword.scss"

const ChangePassword = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const history = useNavigate();

    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [validPassword, setValidPassword] = useState(null);
    //Redux State
    const {
        username,
        session,
        openModalChangePassword,
        errorChangePassword,
        resultChangePassword,
    } = useSelector(state => state.loginRedux);

    const closeModal = () => {
        dispatch(loginOpenModalChangePassword())
    }

    useEffect(() => {
        if (resultChangePassword) {
            NotificationManager.success(messages['change_password_password_is_changed'], messages['change_password_title'], 3000, null, null, '', null);
            setNewPassword("")
            setConfirmNewPassword("")
            setValidPassword("")
            dispatch(clearRedux("LOGIN"))
        }
        if (errorChangePassword) {
            NotificationManager.error(messages['change_password_it_is_not_posible_change_password'], messages['change_password_title'], 3000, null, null, '', null);
            dispatch(clearRedux("LOGIN", { errorChangePassword: false }))
        }
    }, [resultChangePassword, errorChangePassword])

    return (
        <Modal
            open={openModalChangePassword}
            title={messages['change_password_title']}
            size="small"
            handleClose={() => closeModal()}
        >
            <ModalBody>
                <Form
                    ref={formRef}
                    onValidSubmit={() => {
                        if (newPassword !== confirmNewPassword) {
                            setValidPassword(messages['change_password_passwords_must_match']);
                            return
                        } else {
                            if (username && session && newPassword) {
                                let checkPassword = passwordValidation(newPassword);
                                if (checkPassword) {
                                    dispatch(forceChangePasswordRequest(
                                        {
                                            username: username?.trim(),
                                            session,
                                            newPassword: newPassword?.trim(),
                                        },
                                        history
                                    ))
                                } else {
                                    NotificationManager.error(
                                        messages['error_password'],
                                        messages['change_password_title'],
                                        3000
                                    );
                                }
                            } else {
                                NotificationManager.error(messages['change_password_the_data_are_not_valid'], messages['change_password_title'], 3000, null, null, '', null);
                            }
                        }
                    }}
                >
                    <div className="change-password-container">
                        <Alert
                            style={{ marginBottom: 5 }}
                            severity="info"
                        >
                            {messages['change_password_it_is_necessary_to_change']}
                        </Alert>
                        <Input
                            label={messages['change_password_username']}
                            disabled
                            required
                            placeholder={messages['change_password_username']}
                            requiredMessage={messages['required_field']}
                            value={username}
                            onChange={(value) => { }}
                        />
                        <div style={{ marginTop: 5 }}>
                            <Input
                                type="password"
                                label={messages['change_password_new_password']}
                                placeholder={messages['change_password_new_password']}
                                value={newPassword || ""}
                                onChange={(value) => setNewPassword(value)}
                                requiredMessage={messages['required_field']}
                                required
                                maxLength={20}
                                minLength={6}
                                minLengthMessage={`${messages['pmusers_min_chars_password']} 6`}
                                maxLengthMessage={`${messages['pmusers_max_chars_password']} 20`}
                            />
                        </div>
                        <div style={{ marginTop: 5 }}>
                            <Input
                                type="password"
                                label={messages['change_password_repeat_new_password']}
                                placeholder={messages['change_password_repeat_new_password']}
                                value={confirmNewPassword || ""}
                                onChange={(value) => setConfirmNewPassword(value)}
                                requiredMessage={messages['required_field']}
                                required
                                maxLength={20}
                                minLength={6}
                                minLengthMessage={`${messages['pmusers_min_chars_password']} 6`}
                                maxLengthMessage={`${messages['pmusers_max_chars_password']} 20`}
                            />
                        </div>
                        {
                            validPassword &&
                            <p style={{ color: 'red', textAlign: 'center', fontSize: 12, marginTop: 10 }}>{validPassword}</p>
                        }
                    </div>
                </Form>
            </ModalBody>
            <ModalFooter>
                <div className="forgot-password-footer">
                    <Button
                        className="btn-cancel"
                        onClick={(e) => {
                            closeModal("")
                        }}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        className="btn-dark-blue"
                        onClick={(e) => {
                            e.preventDefault();
                            formRef.current?.submit();
                        }}
                    >
                        {messages['save']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default ChangePassword;